module.exports = __webpack_public_path__ + "static/media/image15.0580ab8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SketchBook/image15.jpg
// module id = 1087
// module chunks = 0